export const ESCOLA_EDIT_FILTER_EDUCACAO_INFANTIL = 0;
export const ESCOLA_EDIT_FILTER_ENSINO_FUNDAMENTAL = 1;
export const ESCOLA_EDIT_FILTER_ENSINO_MEDIO = 2;
export const ESCOLA_EDIT_FILTER_ESPECIALIZADO = 3;
export const ESCOLA_EDIT_FILTER_EJA = 4;
export const ESCOLA_EDIT_FILTER_OUTRO = 5;

const allEtapasDaEducacao = [];
allEtapasDaEducacao[ESCOLA_EDIT_FILTER_EDUCACAO_INFANTIL] = {
  name: 'Educação Infantil',
};
allEtapasDaEducacao[ESCOLA_EDIT_FILTER_ENSINO_FUNDAMENTAL] = {
  name: 'Ensino Fundamental',
};
allEtapasDaEducacao[ESCOLA_EDIT_FILTER_ENSINO_MEDIO] = {
  name: 'Ensino Médio',
};

allEtapasDaEducacao[ESCOLA_EDIT_FILTER_ESPECIALIZADO] = {
  name: 'Especializado',
};

allEtapasDaEducacao[ESCOLA_EDIT_FILTER_EJA] = {
  name: 'Eja',
};

allEtapasDaEducacao[ESCOLA_EDIT_FILTER_OUTRO] = {
  name: 'Outro',
};

function getName(index) {
  if (index < allEtapasDaEducacao.length) {
    return allEtapasDaEducacao[index].name;
  }
  return null;
}

export { allEtapasDaEducacao, getName };
